/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PlatformApiResultOfDataSourceResultDtoOfUserGroupSimpleDto } from '../models/platform-api-result-of-data-source-result-dto-of-user-group-simple-dto';
import { PlatformApiResultOfIEnumerableOfGuid } from '../models/platform-api-result-of-i-enumerable-of-guid';
import { PlatformApiResultOfUserGroupDto } from '../models/platform-api-result-of-user-group-dto';
import { deleteUsergroupsActionRemovepagefeatureId } from '../fn/user-group/delete-usergroups-action-removepagefeature-id';
import { DeleteUsergroupsActionRemovepagefeatureId$Params } from '../fn/user-group/delete-usergroups-action-removepagefeature-id';
import { deleteUsergroupsId } from '../fn/user-group/delete-usergroups-id';
import { DeleteUsergroupsId$Params } from '../fn/user-group/delete-usergroups-id';
import { deleteUsergroupsUsergroupidActionRemoveappAppid } from '../fn/user-group/delete-usergroups-usergroupid-action-removeapp-appid';
import { DeleteUsergroupsUsergroupidActionRemoveappAppid$Params } from '../fn/user-group/delete-usergroups-usergroupid-action-removeapp-appid';
import { deleteUsergroupsUsergroupidActionRemoveuseraccountUseraccountid } from '../fn/user-group/delete-usergroups-usergroupid-action-removeuseraccount-useraccountid';
import { DeleteUsergroupsUsergroupidActionRemoveuseraccountUseraccountid$Params } from '../fn/user-group/delete-usergroups-usergroupid-action-removeuseraccount-useraccountid';
import { getUsergroupsUsergroupidQueryAuthorizedapps } from '../fn/user-group/get-usergroups-usergroupid-query-authorizedapps';
import { GetUsergroupsUsergroupidQueryAuthorizedapps$Params } from '../fn/user-group/get-usergroups-usergroupid-query-authorizedapps';
import { postUsergroups } from '../fn/user-group/post-usergroups';
import { PostUsergroups$Params } from '../fn/user-group/post-usergroups';
import { postUsergroupsActionAddpagefeature } from '../fn/user-group/post-usergroups-action-addpagefeature';
import { PostUsergroupsActionAddpagefeature$Params } from '../fn/user-group/post-usergroups-action-addpagefeature';
import { postUsergroupsActionAdduseraccount } from '../fn/user-group/post-usergroups-action-adduseraccount';
import { PostUsergroupsActionAdduseraccount$Params } from '../fn/user-group/post-usergroups-action-adduseraccount';
import { postUsergroupsQueryDatasource } from '../fn/user-group/post-usergroups-query-datasource';
import { PostUsergroupsQueryDatasource$Params } from '../fn/user-group/post-usergroups-query-datasource';
import { putUsergroups } from '../fn/user-group/put-usergroups';
import { PutUsergroups$Params } from '../fn/user-group/put-usergroups';

@Injectable({ providedIn: 'root' })
export class PlatformUserGroupService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postUsergroupsQueryDatasource()` */
  static readonly PostUsergroupsQueryDatasourcePath = '/api/usergroups/query/datasource';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUsergroupsQueryDatasource()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUsergroupsQueryDatasource$Response(params: PostUsergroupsQueryDatasource$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfUserGroupSimpleDto>> {
    return postUsergroupsQueryDatasource(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUsergroupsQueryDatasource$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUsergroupsQueryDatasource(params: PostUsergroupsQueryDatasource$Params, context?: HttpContext): Observable<PlatformApiResultOfDataSourceResultDtoOfUserGroupSimpleDto> {
    return this.postUsergroupsQueryDatasource$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfUserGroupSimpleDto>): PlatformApiResultOfDataSourceResultDtoOfUserGroupSimpleDto => r.body)
    );
  }

  /** Path part for operation `putUsergroups()` */
  static readonly PutUsergroupsPath = '/api/usergroups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putUsergroups()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putUsergroups$Response(params: PutUsergroups$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserGroupDto>> {
    return putUsergroups(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putUsergroups$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putUsergroups(params: PutUsergroups$Params, context?: HttpContext): Observable<PlatformApiResultOfUserGroupDto> {
    return this.putUsergroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserGroupDto>): PlatformApiResultOfUserGroupDto => r.body)
    );
  }

  /** Path part for operation `postUsergroups()` */
  static readonly PostUsergroupsPath = '/api/usergroups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUsergroups()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUsergroups$Response(params: PostUsergroups$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserGroupDto>> {
    return postUsergroups(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUsergroups$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUsergroups(params: PostUsergroups$Params, context?: HttpContext): Observable<PlatformApiResultOfUserGroupDto> {
    return this.postUsergroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserGroupDto>): PlatformApiResultOfUserGroupDto => r.body)
    );
  }

  /** Path part for operation `deleteUsergroupsId()` */
  static readonly DeleteUsergroupsIdPath = '/api/usergroups/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUsergroupsId()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUsergroupsId$Response(params: DeleteUsergroupsId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserGroupDto>> {
    return deleteUsergroupsId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUsergroupsId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUsergroupsId(params: DeleteUsergroupsId$Params, context?: HttpContext): Observable<PlatformApiResultOfUserGroupDto> {
    return this.deleteUsergroupsId$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserGroupDto>): PlatformApiResultOfUserGroupDto => r.body)
    );
  }

  /** Path part for operation `postUsergroupsActionAddpagefeature()` */
  static readonly PostUsergroupsActionAddpagefeaturePath = '/api/usergroups/action/addpagefeature';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUsergroupsActionAddpagefeature()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUsergroupsActionAddpagefeature$Response(params: PostUsergroupsActionAddpagefeature$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserGroupDto>> {
    return postUsergroupsActionAddpagefeature(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUsergroupsActionAddpagefeature$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUsergroupsActionAddpagefeature(params: PostUsergroupsActionAddpagefeature$Params, context?: HttpContext): Observable<PlatformApiResultOfUserGroupDto> {
    return this.postUsergroupsActionAddpagefeature$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserGroupDto>): PlatformApiResultOfUserGroupDto => r.body)
    );
  }

  /** Path part for operation `deleteUsergroupsActionRemovepagefeatureId()` */
  static readonly DeleteUsergroupsActionRemovepagefeatureIdPath = '/api/usergroups/action/removepagefeature/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUsergroupsActionRemovepagefeatureId()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUsergroupsActionRemovepagefeatureId$Response(params: DeleteUsergroupsActionRemovepagefeatureId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserGroupDto>> {
    return deleteUsergroupsActionRemovepagefeatureId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUsergroupsActionRemovepagefeatureId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUsergroupsActionRemovepagefeatureId(params: DeleteUsergroupsActionRemovepagefeatureId$Params, context?: HttpContext): Observable<PlatformApiResultOfUserGroupDto> {
    return this.deleteUsergroupsActionRemovepagefeatureId$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserGroupDto>): PlatformApiResultOfUserGroupDto => r.body)
    );
  }

  /** Path part for operation `deleteUsergroupsUsergroupidActionRemoveappAppid()` */
  static readonly DeleteUsergroupsUsergroupidActionRemoveappAppidPath = '/api/usergroups/{userGroupId}/action/removeapp/{appId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUsergroupsUsergroupidActionRemoveappAppid()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUsergroupsUsergroupidActionRemoveappAppid$Response(params: DeleteUsergroupsUsergroupidActionRemoveappAppid$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserGroupDto>> {
    return deleteUsergroupsUsergroupidActionRemoveappAppid(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUsergroupsUsergroupidActionRemoveappAppid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUsergroupsUsergroupidActionRemoveappAppid(params: DeleteUsergroupsUsergroupidActionRemoveappAppid$Params, context?: HttpContext): Observable<PlatformApiResultOfUserGroupDto> {
    return this.deleteUsergroupsUsergroupidActionRemoveappAppid$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserGroupDto>): PlatformApiResultOfUserGroupDto => r.body)
    );
  }

  /** Path part for operation `postUsergroupsActionAdduseraccount()` */
  static readonly PostUsergroupsActionAdduseraccountPath = '/api/usergroups/action/adduseraccount';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUsergroupsActionAdduseraccount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUsergroupsActionAdduseraccount$Response(params: PostUsergroupsActionAdduseraccount$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserGroupDto>> {
    return postUsergroupsActionAdduseraccount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUsergroupsActionAdduseraccount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUsergroupsActionAdduseraccount(params: PostUsergroupsActionAdduseraccount$Params, context?: HttpContext): Observable<PlatformApiResultOfUserGroupDto> {
    return this.postUsergroupsActionAdduseraccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserGroupDto>): PlatformApiResultOfUserGroupDto => r.body)
    );
  }

  /** Path part for operation `deleteUsergroupsUsergroupidActionRemoveuseraccountUseraccountid()` */
  static readonly DeleteUsergroupsUsergroupidActionRemoveuseraccountUseraccountidPath = '/api/usergroups/{userGroupId}/action/removeuseraccount/{userAccountId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUsergroupsUsergroupidActionRemoveuseraccountUseraccountid()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUsergroupsUsergroupidActionRemoveuseraccountUseraccountid$Response(params: DeleteUsergroupsUsergroupidActionRemoveuseraccountUseraccountid$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserGroupDto>> {
    return deleteUsergroupsUsergroupidActionRemoveuseraccountUseraccountid(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUsergroupsUsergroupidActionRemoveuseraccountUseraccountid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUsergroupsUsergroupidActionRemoveuseraccountUseraccountid(params: DeleteUsergroupsUsergroupidActionRemoveuseraccountUseraccountid$Params, context?: HttpContext): Observable<PlatformApiResultOfUserGroupDto> {
    return this.deleteUsergroupsUsergroupidActionRemoveuseraccountUseraccountid$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserGroupDto>): PlatformApiResultOfUserGroupDto => r.body)
    );
  }

  /** Path part for operation `getUsergroupsUsergroupidQueryAuthorizedapps()` */
  static readonly GetUsergroupsUsergroupidQueryAuthorizedappsPath = '/api/usergroups/{userGroupId}/query/authorizedapps';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsergroupsUsergroupidQueryAuthorizedapps()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsergroupsUsergroupidQueryAuthorizedapps$Response(params: GetUsergroupsUsergroupidQueryAuthorizedapps$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfIEnumerableOfGuid>> {
    return getUsergroupsUsergroupidQueryAuthorizedapps(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsergroupsUsergroupidQueryAuthorizedapps$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsergroupsUsergroupidQueryAuthorizedapps(params: GetUsergroupsUsergroupidQueryAuthorizedapps$Params, context?: HttpContext): Observable<PlatformApiResultOfIEnumerableOfGuid> {
    return this.getUsergroupsUsergroupidQueryAuthorizedapps$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfIEnumerableOfGuid>): PlatformApiResultOfIEnumerableOfGuid => r.body)
    );
  }

}
